<template>
  <div v-loading="loading">
    <div class="connect_main">
      <!-- <p class="fb">关联产品规格</p> -->
      <div class="goods_info" v-if="productData">
        <div class="img_box"><img class="coverimg" :src="productData.img" /></div>
        <div class="con_box">
          <p class="name">{{productData.name}}</p>
          <p class="id">DD商品ID：{{productData.goods_id}}</p>
          <p class="id">PDD商品ID：{{pdd_product_id}}</p>
        </div>
      </div>
      <!-- <div class="add_line">
        <div style="display: flex;gap: 1em;">
					<el-button type="primary" @click="syncProduct()" :loading="is_syncing">同步抖店商品</el-button>
          <p class="add_btn" @click="showChangeLog()">历史记录</p>
        </div>
        <p class="clear" @click="clearSelConfig()"><i class="iconfont icon-delete"></i>清空匹配的规格</p>
      </div> -->
      <div class="config_wrap mt-5">
        <div class="config_table">
          <el-table :data="dd_sku_list" height="450">
            <el-table-column label="当前关联PDD产品属性" prop="scope" width="">
              <template slot-scope="scope">
                <p class="ct_name">
									<img class="pic" v-if="scope.row.pdd_sku&&scope.row.pdd_product_sku_id" @click="openImg(scope.row.pdd_sku.pdd_product_sku_img,scope.row.pdd_sku.pdd_product_sku_name)" :src="scope.row.pdd_sku.pdd_product_sku_img" alt="">
									{{(scope.row.pdd_product_sku_id&&scope.row.pdd_sku)?scope.row.pdd_sku.pdd_product_sku_name:'-'}}
								</p>
								<span class="active" v-if="scope.row.current_order_sku">当前订单规格</span>
              </template>
            </el-table-column>
            <el-table-column label="卖价" prop="scope" width="150">
              <template slot-scope="scope">
                <p class="ct_price">￥{{scope.row.price}}</p>
              </template>
            </el-table-column>
            <el-table-column label="抖店产品属性" prop="scope" width="">
              <template slot-scope="scope">
                <p class="ct_name">
									<img class="pic"  @click="openImg(scope.row.pic,scope.row.dd_spec_value)" :src="scope.row.pic" alt="">
									{{scope.row.dd_spec_value}}
								</p>
              </template>
            </el-table-column>
            <el-table-column label="更改关联产品" prop="scope" width="400">
              <template slot-scope="scope">
                <el-select v-model="scope.row.sel_pdd_product_sku_id" @change="onSelPddProductSkuId" placeholder="请选择" @visible-change="selectChange" clearable>
                  <el-option
                      v-for="(item,index) in current_sku" :key="index"
                      :label="item.pdd_product_sku_name"
                      :value="item.pdd_product_sku_id"
											v-show="!item.is_selected||scope.row.sel_pdd_product_sku_id==item.pdd_product_sku_id"
											>
											<div class="pdd_sku_info">
												<img class="pdd_sku_pic" @click.stop="openImg(item.pdd_product_sku_img,item.pdd_product_sku_name)" :src="item.pdd_product_sku_img"/>
												<span>{{item.pdd_product_sku_name}}</span>
											</div>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btn_wrap">
					<el-button type="primary" size="mini" @click="getPddSkuInfo(1)" :loading="is_geting">获取拼多多规格</el-button>
          <p class="btn" @click="configSubmit()">确定</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHead from '@/components/myHead/myhead';
import myFoot from '@/components/myFoot/myfoot';
import { mapActions,mapState,mapMutations } from "vuex";

export default {
  name: "goodsConnectBox",
  data() {
    return {
			shop_id: "",
      pdd_product_id:"",
			dd_goods_id: "",
      loading: true,
      productData:"",
      dd_sku_list:[],
      links_list:[{links:"",isUse:false,product_id:""}],
      isSubmit:false,
      current_sku:[],
      search_input:"",
      isSearch:false,
      searchLoading:false,
      order:"_score",
      product_loading:false,
			sku_id: '',
			order_product_id: '',
			sku_exist: false,
			is_syncing: false,
			is_do_sync: false,
			is_geting: false,
    }
  },
  components:{
    myHead,myFoot
  },

  methods: {
    ...mapActions({
      GetGoodsRelativeInfoData:"ucenter_order/GetGoodsRelativeInfoData",
      // doSubmitRelative:"ucenter_order/doSubmitRelative",
      // opCheckoutSkuRelative:"ucenter_order/opCheckoutSkuRelative",
			doSyncDdProductInfo:"ucenter_order/doSyncDdProductInfo",
			doSubmitPddSkuRelative:"ucenter_order/doSubmitPddSkuRelative",
			doOrderGetPddSkuInfo:"ucenter_order/doOrderGetPddSkuInfo",
    }),
		onSelPddProductSkuId(){
			let current_sku = this.current_sku
			this.current_sku = this.setPddSkuSelected(current_sku)
		},
		setPddSkuSelected(pddSkuList){
			let sel_ids = []
			let dd_sku_list = this.dd_sku_list
			for(var i in dd_sku_list){
				if(dd_sku_list[i].sel_pdd_product_sku_id){
					sel_ids.push(dd_sku_list[i].sel_pdd_product_sku_id)
				}
			}
			for(var i in pddSkuList){
				if(sel_ids.findIndex(val => val == pddSkuList[i].pdd_product_sku_id) !== -1){
					pddSkuList[i].is_selected = true
				}else{
					pddSkuList[i].is_selected = false
				}
			}
			return pddSkuList
		},
		openImg(pic,name) {
			let htm = ''
			if(!pic){
				htm = '<p>图片未更新</p>'
			}else{
				htm = '<img width="100%" style="object-fit: cover;margin-right: 10px;" src="' + pic + '" alt="">'
			}

			this.$alert(htm, name, {
				dangerouslyUseHTMLString: true,
				showClose: false,
				confirmButtonText: '关闭',
				closeOnClickModal: true,
				closeOnPressEscape: true,
				customClass: 'zdy-message-box'
			});
		},
    //同步抖店商品
		syncProduct(){
			this.doSyncDdProductInfo({data:{dd_goods_id:this.dd_goods_id,shop_id:this.shop_id},success:(res)=>{
				this.is_do_sync = true
				if(res.code == 200){
					this.getProductInfo()
				}else{
					this.$message({message: res.msg,type: 'error',})
				}
			}})
		},
		clean(){
			this.productData = null
			this.dd_sku_list = []
			this.is_do_sync = false
			this.is_syncing = false
			this.current_sku = []
			this.is_geting = false
			this.loading = true
		},
    init(pdd_product_id,dd_goods_id,shop_id,dd_sku_id=0,order_product_id=0){//获取商品信息
      this.pdd_product_id = pdd_product_id;
			this.shop_id = shop_id
			this.dd_goods_id = dd_goods_id
			this.sku_id = dd_sku_id
			this.order_product_id = order_product_id
      this.getProductInfo()
    },
		//轮询获取拼多多规格信息
		getPddSkuInfo(re_collect=0){
			let that = this
			that.is_geting = true
			this.loading = true;
			if(re_collect==1){
				this.current_sku = []
				this.dd_sku_list = []
			}
			let params = {pdd_product_id:this.pdd_product_id,dd_goods_id:this.dd_goods_id,dd_sku_id:this.sku_id,order_product_id:this.order_product_id,re_collect:re_collect}
			this.doOrderGetPddSkuInfo({data:params,success:(res)=>{
			    if(res.code===200){

						if(res.data == 100){
							setTimeout(function(){
								if(that.is_geting){
									that.getPddSkuInfo()
								}
							},3000)
							return;
						}
			      this.loading = false;
						this.is_geting = false;
			      this.productData = JSON.parse(JSON.stringify(res.data))
			      let skuList = JSON.parse(JSON.stringify(res.data.dd_sku))
			      let pddSkuList = JSON.parse(JSON.stringify(res.data.pdd_sku))


			      for(let i in skuList){
			        skuList[i].sku = []
			        skuList[i].sel_pdd_product_sku_id = ""
			        skuList[i].current_order_sku = false

							var cindex = pddSkuList.findIndex(val => val.pdd_product_sku_id == skuList[i].pdd_product_sku_id)
							if(cindex !== -1){
								skuList[i].sel_pdd_product_sku_id = skuList[i].pdd_product_sku_id
							}

							var nindex = pddSkuList.findIndex(val => val.pdd_product_sku_name == skuList[i].dd_spec_value)
							if(cindex === -1 && nindex !== -1){
								skuList[i].sel_pdd_product_sku_id = pddSkuList[nindex].pdd_product_sku_id
							}
			      }
						if(this.sku_id){
							let sidx = skuList.findIndex(v => v.sku_id==this.sku_id)
							if(sidx === -1){
								this.sku_exist = false
								if(this.is_do_sync){
									 this.$alert('该商品规格不存在，请检查抖店商品是否已删除或更新商品规格');
									 return;
								}
								this.syncProduct()
								return;
							}else{
								this.sku_exist = true
								let first_sku = skuList.splice(sidx, 1)[0]
								first_sku.current_order_sku = true
								skuList.unshift(first_sku)
							}
						}

			      this.dd_sku_list = skuList
						this.current_sku = this.setPddSkuSelected(pddSkuList)

			    } else {
						setTimeout(function(){
							if(that.is_geting){
								that.getPddSkuInfo()
							}
						},3000)
			    }
			  }})
		},
		getProductInfo(){
			let that = this
			that.loading = true
			let params = {pdd_product_id:this.pdd_product_id,dd_goods_id:this.dd_goods_id,dd_sku_id:this.sku_id}
			this.GetGoodsRelativeInfoData({data:params,success:(res)=>{
					that.loading = false
			    if(res.code===200){
			      // console.log('relative info',res,this.is_do_sync)

						if(res.data == 100){
							if(this.is_do_sync){
								this.$message({message: "该商品不存在，请检查抖店商品",type: 'error',});
								return;
							}
							this.syncProduct()
							return;
						}

			      this.productData = JSON.parse(JSON.stringify(res.data))
			      let skuList = JSON.parse(JSON.stringify(res.data.dd_sku))
			      let pddSkuList = JSON.parse(JSON.stringify(res.data.pdd_sku))

			      for(let i in skuList){
			        skuList[i].sku = []
			        skuList[i].sel_pdd_product_sku_id = ""
			        skuList[i].current_order_sku = false

							var cindex = pddSkuList.findIndex(val => val.pdd_product_sku_id == skuList[i].pdd_product_sku_id)
							if(cindex !== -1){
								skuList[i].sel_pdd_product_sku_id = skuList[i].pdd_product_sku_id
							}

							var nindex = pddSkuList.findIndex(val => val.pdd_product_sku_name == skuList[i].dd_spec_value)
							if(cindex === -1 && nindex !== -1){
								skuList[i].sel_pdd_product_sku_id = pddSkuList[nindex].pdd_product_sku_id
							}
			      }

						if(this.sku_id){
							let sidx = skuList.findIndex(v => v.sku_id==this.sku_id)
							if(sidx === -1){
								this.sku_exist = false
								if(this.is_do_sync){
									 this.$alert('该商品规格不存在，请检查抖店商品是否已删除或更新商品规格');
									 return;
								}
								this.syncProduct()
								return;
							}else{
								this.sku_exist = true
								let first_sku = skuList.splice(sidx, 1)[0]
								first_sku.current_order_sku = true
								skuList.unshift(first_sku)
							}
						}

			      this.dd_sku_list = skuList
						this.current_sku = this.setPddSkuSelected(pddSkuList)
			      this.$nextTick(function(){
							that.loading = false;
						})
			    } else {
			      this.$message({message: res.msg,type: 'error',});
			    }
			  }})
		},

    openDetail(routePath){
      // const fullPath = this.$router.resolve(routePath).href;
      window.open(routePath, '_blank');
    },


    configSubmit(){//关联商品规格

      let that = this
      let skuList = this.dd_sku_list
      let current_sku = this.current_sku
      this.loading = true;
      let param = []
			//有变更的才插入提交数据
      for(let i in skuList){
        if(skuList[i].sel_pdd_product_sku_id&&skuList[i].pdd_product_sku_id!=skuList[i].sel_pdd_product_sku_id){

          let pdd_product_sku_idx = current_sku.findIndex(val => val.pdd_product_sku_id == skuList[i].sel_pdd_product_sku_id)

          param.push({"product_sku_id":skuList[i].product_sku_id,"sku_id":skuList[i].sku_id,"pdd_product_sku_id":skuList[i].sel_pdd_product_sku_id})
        }
      }
			// console.log(param);
			this.doSubmitPddSkuRelative({data:{'sku_rel':param,'pdd_product_id':this.pdd_product_id},success:(res)=>{
				// console.log(res)
				this.loading = false;
				if(res.code == 200){
					this.getProductInfo()
					//关闭弹窗
					this.$message({message: res.msg,type: 'success',duration:1000,onClose:(res)=>{
						that.$parent.closeConnectGood();
					}})
				}else{
					this.$message({message: res.msg,type: 'error',})
				}
			}})

		},
    clearSelConfig(){//清除选中的关联规格
      let skuList = this.dd_sku_list
      for(let i in skuList){
        skuList[i].sel_pdd_product_sku_id = ""
      }
      this.dd_sku_list = skuList
    },

    selectChange(value){//检测无规格
      if(value && this.current_sku.length==0){
        this.$message({message: '暂无数据，请先获取拼多多规格信息！',type: 'warning',});
      }
    },



  }
}
</script>

<style scoped>
.ct_name{display: flex;align-items: center;text-align: justify;}
.ct_name .pic{width: 40px;height: 40px;margin-right: 5px;cursor: pointer;}
.pdd_sku_info{display: flex;align-items: center;}
.pdd_sku_info .pdd_sku_pic{width: 30px;height: 30px;margin-right: 10px;}
.tongkuan_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.tongkuan_mask.active{visibility: visible;opacity: 1;}
.tongkuan_mask .tongkuan_main{width: 1200px;height: 800px;box-sizing: border-box;padding: 20px 30px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;display: flex;flex-direction: column;}
.tongkuan_mask.active .tongkuan_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.tongkuan_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.tongkuan_main .title{font-size: 20px;line-height: 1;}
.tongkuan_main .title2{margin-top: 10px;font-size: 24px;text-align: center;line-height: 1;}
.tongkuan_main .search_wrap{margin: 10px 50px;}
.tongkuan_main .content_wrap{display: flex;flex-direction: column;flex: 1;overflow-y: auto;}
.tongkuan_main .tk_content{flex: 1;height: 0;overflow: hidden auto;display: flex;flex-wrap: wrap;align-items: flex-start;padding-bottom: 10px;padding-left: 4px;}
.tk_content .product{width: 210px;height: auto;margin: 18px 18px 0 0;border-radius: 6px;box-shadow: 0 0 5px 0 #eee;overflow: hidden;}
.tk_content .product:nth-child(5n){margin-right: 0;}
.tk_content .product .img_box{width: 100%;height: 210px;overflow: hidden;}
.tk_content .product .title{margin: 10px 10px 0;font-size: 14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;cursor: pointer;}
.tk_content .product .title:hover{color: var(--red);text-decoration: underline;}
.tk_content .product .price_line{padding: 10px;display: flex;justify-content: space-between;align-items: center;}
.tk_content .product .price_line .price{font-size: 14px;color: var(--red);}
.turn_page{display: flex;justify-content: flex-end;margin-top: 20px;}
.connect_main{margin-top: 30px;width: 100%;height: auto;box-sizing: border-box;padding: 30px 40px;background: #fff;line-height: 1;}
.goods_info{display: flex;position: relative;}
.goods_info .img_box{width: 48px;height: 48px;background: #eee;border-radius: 6px;overflow: hidden;}
.goods_info .con_box{flex: 1;width: 0;margin-left: 10px;font-size: 12px;}
.goods_info .con_box .name{line-height: 16px;}
.goods_info .con_box .id{color: #999999;margin-top: 8px;}
.goods_info .search_btn{position: absolute;right: 50px;top: 50%;transform: translateY(-50%);z-index: 22;}
.goods_info .search_btn:hover ,.goods_info .search_btn:focus{border-color: var(--red);color: var(--red);}
.table_wrap{margin-top: 30px;font-size: 12px;}
.get_config{color: var(--red);cursor: pointer;}
.get_config:hover{text-decoration: underline;}
.table_wrap .pingtai{width: 80px;margin: 0 auto;text-align: left;box-sizing: border-box;padding-left: 20px;}
.add_line{display: flex;justify-content: space-between;align-items: flex-end;margin: 30px 0 20px;}
.add_line .add_btn{width: 102px;height: 35px;box-sizing: border-box;border: 1px solid var(--red);border-radius: 4px;cursor: pointer;display: flex;justify-content: center;align-items: center;font-size: 14px;color: var(--red);}
.add_line .clear{font-size: 14px;color: #999999;display: flex;align-items: center;cursor: pointer;}
.add_line .clear .iconfont{font-size: 14px;margin-right: 8px}
.config_wrap .title_wrap{width: 100%;height: 50px;background: #f5f5f5;box-sizing: border-box;border: 1px solid #eee;display: flex;align-items: center;font-size: 14px;color: #999}
.config_wrap .title_wrap .t1{width: 320px;margin: 0 16px;}
.config_wrap .title_wrap .t2{width: 80px;text-align: center;}
.config_wrap .title_wrap .t3{width: 120px;margin: 0 30px 0 20px;text-align: center;}
.config_wrap .title_wrap .t4{flex: 1;width: 0;}
.config_wrap .content_wrap{margin-top: 20px;padding-bottom: 40px;border-bottom: 1px solid #eee;height: 220px;overflow-y: auto;overflow-x: hidden;font-size: 14px;}
.content_wrap .content_line{display: flex;align-items: flex-start;margin-top: 26px;}
.content_wrap .content_line:first-child{margin-top: 0;}
.content_line .b1{width: 320px;margin: 0 16px;line-height: 20px;box-sizing: border-box;padding-right: 50px;}
.content_line .b2{width: 80px;text-align: center;}
.content_line .b3{width: 120px;margin: 0 30px 0 20px;display: flex;justify-content: center;align-items: center;}
.content_line .b4{flex: 1;width: 0;display: flex;}
.content_line .b3 .t{margin-right: 10px;}
.btn_wrap{margin-top: 20px;display: flex;justify-content: flex-end;}
.btn_wrap .btn{min-width: 120px;padding:0 10px;height: 32px;border-radius: 4px;display: flex;justify-content: center;align-items: center;margin-left: 20px;cursor: pointer;font-size: 12px;box-sizing: border-box;}
.btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;}
.btn_wrap .btn:nth-child(2){border: 1px solid #ddd;color: #fff;background-color: #409eff;}
.btn_wrap .btn:nth-child(2):hover{background-color: #d5efff;color: #409eff;border: 1px solid #409eff;}
.tongkuan_main .el-button--primary ,.tongkuan_main .el-button--primary:hover{background-color: var(--red) !important;border-color: var(--red) !important;}

.sku_change_log_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.sku_change_log_mask.active{visibility: visible;opacity: 1;}
.sku_change_log_mask .sku_change_log_main{width: 1200px;height: 650px;box-sizing: border-box;padding: 20px 30px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;display: flex;flex-direction: column;}
.sku_change_log_mask.active .sku_change_log_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.sku_change_log_mask .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.sku_change_log_mask .title{font-size: 20px;line-height: 1;}
</style>
<style>

.page_links{line-height: 1;font-size: 14px;color: #999999;display: flex;margin-top: 25px;}
.page_links .el-breadcrumb__inner{font-weight: bold !important;color: #333 !important;}
.page_links .el-breadcrumb__inner.is-link{font-weight: initial !important;color: #999 !important;}
.page_links .el-breadcrumb__inner.is-link:hover{color: #f0423f !important;text-decoration: underline;}

.tongkuan_main .search_wrap .el-input__inner{border-radius: 6px;font-size: 16px;}
.tongkuan_main .search_wrap .el-input__suffix{right: 1px;display: flex;top: 1px;border-radius: 0 6px 6px 0;height: 38px;overflow: hidden;border-left: 1px solid #ddd;}
.tongkuan_main .search_wrap .el-input__suffix .el-input__suffix-inner{width: 80px;height: 38px;}
.tongkuan_main .search_wrap .el-input__suffix .el-input__suffix-inner .icons{width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;background: #f5f5f5;cursor: pointer;}
.tongkuan_main .search_wrap .el-input__suffix .el-input__suffix-inner .icons .iconfont{font-size: 16px;color: #999;}
.table_wrap .el-table::before{display: none;}
.table_wrap .el-table .el-table_1_column_2 .cell .num{color: #999;}
.table_wrap .el-table th.el-table__cell{background: #fff6f7;border-bottom: none !important;color: #666666;padding: 12px 0;}
.table_wrap .el-table .el-table__cell{padding: 24px 0;}
.table_wrap .el-table .cell{padding: 0 20px;text-align: center;font-size: 12px;color: #333;}
.table_wrap .el-table .el-table_1_column_1 .cell{text-align: center;}
.table_wrap .el-table .el-table_1_column_2 .cell{padding: 0 10px;}
.table_wrap .el-table th.el-table_1_column_2 .cell{text-align: left;}
.table_wrap .el-table td.el-table__cell, .table_wrap .el-table th.el-table__cell.is-leaf{border-bottom: none;}

.config_table .el-table__header-wrapper{border: 1px solid #eee !important;box-sizing: border-box;}
.config_table .el-table th.el-table__cell{background: #f5f5f5;border: none !important;color: #999;padding: 13.5px 0;}
.config_table .el-table td.el-table__cell{border-bottom: none !important;}
.config_table .el-table .cell{padding: 0 16px !important;}
.config_table .el-table td.el-table__cell div{width: 100%;}
.config_table .el-table__body-wrapper::-webkit-scrollbar{width:4px;}
.config_table .el-table__body-wrapper::-webkit-scrollbar-thumb{background: #DDDDDD;border-radius: 4px;}
.config_table .el-table__body-wrapper::-webkit-scrollbar-track{background: #F2F2F2;border-radius: 4px;}

.image-uploader{position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0;}
.search-image{width: 140px;height: 140px;object-fit: contain;margin: 20px auto;display: block;}
.search_wrap .search_box{height: 50px;box-sizing: border-box;background-color: #ffffff;border-radius: 4px 0vw 0vw 4px;border: solid 2px #fa5757;display: flex;align-items: center;position: relative;}
.search_wrap .search_box .type{width: 84px;color: #333333;cursor: pointer;text-align: center;line-height: 26px;border-right: 1px solid #ddd;}
.search_wrap .search_box .in{flex: 1;width: 0;margin: 0 15px;color: #333333;font-size: 16px;}
.search_wrap .search_box .el-icon-search{margin-left: 14px;font-size: 20px;color: #999;cursor: pointer;}
.search_wrap .search_box .icon-xiangji{margin-right: 14px;font-size: 24px;color: #999;cursor: pointer;position: relative;}
.search_wrap .search_btn{width: 132px;height: 50px;background-image: linear-gradient(180deg, #fa5757 0%, #fb6d6d 100%), linear-gradient(#ffffff, #ffffff);background-blend-mode: normal, normal;border-radius: 0vw 4px 4px 0vw;display: flex;justify-content: center;align-items: center;color: #ffffff;font-weight: bold;cursor: pointer;}


.content_line .b4 .el-select{width: 220px;margin-right: 10px;}
.el-input-number__decrease:hover, .el-input-number__increase:hover ,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path ,.el-select-dropdown__item.selected{color: var(--red);}
.input_number .el-input__inner:hover ,.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled), .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) ,.el-input__inner:focus ,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner ,.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}

.screen_wrap{width: 100%;height: 47px;border-bottom: 1px solid #eeeeee;display: flex;align-items: center;justify-content: space-between}
.screen_wrap .title{
  font-weight: bold;
  //margin-right: 60px;
}
.screen_wrap .title span{color: #fa5757;}
.order_sort{
  display: flex;
  align-items: center;
  div{
    margin-right: 20px;
    cursor: pointer;
    font-size: 14px;
    color: #999999;
  }
  .active{
    color: #fa5757;
  }
}
.active{
    color: #fa5757;
  }
</style>
